import { useContext } from 'react';
import { VtxThemeContext } from '../vtx-theme-provider';

/**
 * 获取配置信息
 * @returns
 */
const useSettings = () => {
    const { theme } = useContext(VtxThemeContext);
    // const theme = 'dark';

    return { theme, isDark: theme === 'dark' };
};

export default useSettings;
